import { useMemo } from 'react';
import ContentCard from '../organisms/ContentCard/ContentCard';
import ApprovalDataTable from '@shared/components/organisms/ApprovalDataTable/ApprovalDataTable';
import useSort from '@shared/hooks/useSort';
import { useInquiryListQuery } from '@features/inquiry/hooks';
import { formatDateToYYYYMMDD } from '@shared/utils/formatDate';

import styles from './InquiryListModal.module.scss';
function getStatusLabel(status) {
  switch (status) {
    case 0:
      return '접수';
    case 1:
      return '처리중';
    case 2:
      return '완료';
    case 3:
      return '반려';
    default:
      return '-';
  }
}
function InquiryListModal() {
  const { data = [], isLoading, isError } = useInquiryListQuery();

  const tableColumns = useMemo(
    () => [
      {
        key: 'inquiryDate',
        label: '일자',
        width: '15%',
        render: (value) => formatDateToYYYYMMDD(value),
      },
      {
        key: 'inquiryType',
        label: '문의유형',
        width: '15%',
        render: (value) => {
          const map = {
            1: '서비스 불편 / 제안',
            2: '시스템 오류(PC/Mobile) 오류 제보',
            3: '서비스 개선 제안',
            4: '기타',
          };
          return map[value] ?? '-';
        },
      },
      {
        key: 'inquiryContent',
        label: '내용',
        width: '30%',
      },
      {
        key: 'comment',
        label: '답변',
        width: '25%',
      },
      {
        key: 'status',
        label: '진행상태',
        width: '15%',
        render: (value) => {
          const map = {
            0: '접수',
            1: '처리중',
            2: '완료',
            3: '반려',
          };
          return map[value] ?? '-';
        },
      },
    ],
    [],
  );

  const { sortedData, sortField, sortDirection, handleSort } = useSort(data, {
    field: 'inquiryDate',
    direction: 'desc',
  });

  if (isLoading) {
    return <ContentCard className={styles.contentCardMarginFix}>로딩 중...</ContentCard>;
  }

  if (isError) {
    return (
      <ContentCard className={styles.contentCardMarginFix}>
        조회 중 오류가 발생했습니다.
      </ContentCard>
    );
  }

  return (
    <ContentCard className={styles.contentCardMarginFix}>
      <div className={styles.tableWrapper}>
        <ApprovalDataTable
          columns={tableColumns}
          data={sortedData}
          onSort={handleSort}
          sortField={{ field: sortField, direction: sortDirection }}
          getRowKey={(item, index) => `${item.idx}_${index}`}
          emptyContent={<div className={styles.emptyCell}>등록된 문의가 없습니다.</div>}
        />
      </div>
    </ContentCard>
  );
}
export default InquiryListModal;
